import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';
import { filterI18nProps } from '../../utils/styledComponentsUtils';

const Span = styled.div`
    font-size: 32px;
`;

interface IProps extends HTMLAttributes<HTMLDivElement> {
    unicode: string
}

const UnicodeRenderer: React.FC<IProps> = (props: IProps) => (
  <Span {...filterI18nProps(props)} dangerouslySetInnerHTML={{ __html: props.unicode }} />
);

export default UnicodeRenderer;
